import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Sidebar } from './Sidebar';

const Layout = () => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center" style={{ background: '#2D0C10' }}>
                <div className="text-sm" style={{ color: '#C49A80' }}>Carregando...</div>
            </div>
        );
    }

    if (!isAuthenticated) return <Navigate to="/login" replace />;

    return (
        <div style={{ padding: '28px', background: '#f4eee5', height: '100vh', boxSizing: 'border-box', overflow: 'hidden' }}>
            <div className="crm-shell">
                <Sidebar />
                <main className="flex-1 overflow-y-auto" style={{ background: '#FFFFFF' }}>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Layout;
